import { useTranslation } from 'react-i18next';

interface GrowthBannerProps {
  onGrowthClick?: () => void;
}

export function GrowthBanner({ onGrowthClick }: GrowthBannerProps) {
  const { t } = useTranslation();

  return (
    <div className="home-culture-banner">
      <div className="home-culture-icon" aria-hidden="true">
        <i className="fas fa-seedling" />
      </div>
      <div className="home-culture-body">
        <p className="home-culture-title">{t('survey.growth.title')}</p>
        <p className="home-culture-sub">{t('survey.growth.message')}</p>
      </div>
      <button className="home-culture-cta" onClick={onGrowthClick} type="button">
        {t('survey.growth.cta')}
        <i className="fas fa-arrow-right" aria-hidden="true" />
      </button>
    </div>
  );
}
